import { render, staticRenderFns } from "./footer-navigation.vue?vue&type=template&id=8b70443c&"
import script from "./footer-navigation.vue?vue&type=script&lang=js&"
export * from "./footer-navigation.vue?vue&type=script&lang=js&"
import style0 from "./_footer-navigation.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports